import { IconName } from './Icon.types';

/** Константа для суффикса анимированных иконок */
export const ANIMATED_ICON_SUFFIX = 'Animated';

/** Хелпер для проверки, является ли иконка анимированной */
export const isAnimatedIcon = (iconName: IconName): boolean => {
    return iconName.endsWith(ANIMATED_ICON_SUFFIX);
};

/** Хелпер для получения имени иконки для отображения */
export const getIconNameToShow = (isAnimatedIconName: boolean, isHovered: boolean, name: IconName): IconName => {
    return isAnimatedIconName && isHovered ? name : (name.replace(ANIMATED_ICON_SUFFIX, '') as IconName);
};
